import { withInstall } from "../utils/index.mjs";
import _TimePicker from "./TimePicker.mjs";
const TimePicker = withInstall(_TimePicker);
var stdin_default = TimePicker;
import { timePickerProps } from "./TimePicker.mjs";
export {
  TimePicker,
  stdin_default as default,
  timePickerProps
};
